// src/utils/messageConfig.ts
export interface MessageConfig {
  welcome: string;
  inactivity: string;
  inactivityDelay: number;
}

const DEFAULT_MESSAGES: MessageConfig = {
  welcome: 'Hi there! I’m your virtual assistant. How can I help today?',
  inactivity: 'Just checking in! Were you able to find what you needed, or would you like some more help?',
  inactivityDelay: 60000 // 1 minute
};

export const getMessageConfig = (): MessageConfig => {
  const config = (window as any).NexlyChat || {};
  
  return {
    welcome: config.welcomeMessage || DEFAULT_MESSAGES.welcome,
    inactivity: config.inactivityMessage || DEFAULT_MESSAGES.inactivity,
    inactivityDelay: config.inactivityDelay || DEFAULT_MESSAGES.inactivityDelay
  };
};